import { FC, useContext } from 'react';
import { NumberInput, NumberInputProps, TextInput } from '@mantine/core';
import { WindowContext } from '../../Service/Context/WindowContext';
import { FormatS } from '../../Service/FormatS';

const FloatNumberInput: FC<NumberInputProps> = ({ ...rest }) => {
  const { sm } = useContext(WindowContext);

  // Use text input for phone to support decimal delimeter chars: "," | "."
  if (sm) {
    const { defaultValue, value, label, onBlur, onChange, sx } = rest;
    const strValue = value?.toString();

    return (
      <TextInput
        defaultValue={defaultValue}
        value={strValue}
        onBlur={onBlur}
        label={label}
        sx={sx}
        onChange={(e) => {
          if (onChange) {
            onChange(FormatS.formatAsCurrency(e.currentTarget.value));
          }
        }}
        onKeyPress={(event) => {
          if (!/[0-9,-\.]/.test(event.key)) {
            event.preventDefault();
          }
        }}
      />
    );
  }
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <NumberInput {...rest} />;
};

export default FloatNumberInput;
